import React from 'react';
import { Button } from 'components/ui/button';
import { Card, CardContent, CardFooter, CardTitle } from 'components/ui/card';

export const SafetyStopScreen: React.FC<{
  onClose: () => void;
  onStartOver?: () => void;
  processing?: boolean;
  error?: string | null;
}> = ({ onClose, onStartOver, processing = false, error = null }) => (
  <div className="rp-safety-shell flex min-h-screen items-center justify-center px-4 py-6" data-testid="roleplay-safety-stop">
    <Card variant="white" disableAnimation maxWidth="large" className="max-w-[33.75rem]">
      <CardTitle title="The practice is paused" subtitle="You matter, and support is available. There is no score here and no judgement." />
      <CardContent variant="form">
        <p className="type-body-s text-foundation-base-darkbase-dark-500">Use your organization’s usual support or emergency channels if you may be in immediate danger.</p>
        <p className="type-body-s mt-2 text-foundation-base-darkbase-dark-400">Safety-only text is kept out of the roleplay and its learning feedback.</p>
        {error && <p role="alert" className="type-body-s mt-3 text-destructive" data-testid="roleplay-safety-stop-error">{error}</p>}
      </CardContent>
      <CardFooter className="flex flex-wrap gap-3 p-0 pt-2">
        <Button variant="secondary" onClick={onClose} data-testid="roleplay-safety-stop-close">Close</Button>
        {onStartOver && (
          <Button variant="secondary" onClick={onStartOver} disabled={processing} data-testid="roleplay-safety-stop-start-over">
            Start a new practice
          </Button>
        )}
      </CardFooter>
    </Card>
  </div>
);
